import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { CONFIG } from '@config';

@Component({
  selector: 'app-gtm-script',
  standalone: true,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GtmScriptComponent implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly document = inject(DOCUMENT);
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    const gtmId = CONFIG.gtmContainerId;

    if (!gtmId || !isPlatformBrowser(this.platformId)) {
      return;
    }

    this.injectGtmScript(gtmId);
    this.injectGtmNoscript(gtmId);
  }

  private injectGtmScript(gtmId: string): void {
    const inlineScriptId = `gtm-inline-${gtmId}`;
    const scriptId = `gtm-script-${gtmId}`;

    if (!this.document.getElementById(inlineScriptId)) {
      const inlineScript = this.renderer.createElement('script') as HTMLScriptElement;

      this.renderer.setAttribute(inlineScript, 'id', inlineScriptId);
      // eslint-disable-next-line @stylistic/max-len, @stylistic/quotes
      inlineScript.text = `window.dataLayer=window.dataLayer||[];window.dataLayer.push({'gtm.start':new Date().getTime(),event:'gtm.js'});`;
      this.renderer.appendChild(this.document.head, inlineScript);
    }

    if (!this.document.getElementById(scriptId)) {
      const script = this.renderer.createElement('script') as HTMLScriptElement;

      this.renderer.setAttribute(script, 'id', scriptId);
      this.renderer.setAttribute(script, 'async', '');
      this.renderer.setAttribute(script, 'src', `https://www.googletagmanager.com/gtm.js?id=${gtmId}`);
      this.renderer.appendChild(this.document.head, script);
    }
  }

  private injectGtmNoscript(gtmId: string): void {
    const noscriptId = `gtm-noscript-${gtmId}`;

    if (this.document.getElementById(noscriptId)) {
      return;
    }

    const noscript = this.renderer.createElement('noscript') as HTMLElement;
    const iframe = this.renderer.createElement('iframe') as HTMLIFrameElement;

    this.renderer.setAttribute(noscript, 'id', noscriptId);
    this.renderer.setAttribute(iframe, 'src', `https://www.googletagmanager.com/ns.html?id=${gtmId}`);
    this.renderer.setAttribute(iframe, 'height', '0');
    this.renderer.setAttribute(iframe, 'width', '0');
    this.renderer.setStyle(iframe, 'display', 'none');
    this.renderer.setStyle(iframe, 'visibility', 'hidden');
    this.renderer.appendChild(noscript, iframe);

    const firstBodyChild = this.document.body.firstChild;

    if (firstBodyChild) {
      this.renderer.insertBefore(this.document.body, noscript, firstBodyChild);
    } else {
      this.renderer.appendChild(this.document.body, noscript);
    }
  }
}
